import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import api from '../services/api';
import './MiCuenta.css';

const MiCuenta = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [estado, setEstado] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [conectando, setConectando] = useState(false);
  const [desconectando, setDesconectando] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const cargarEstado = async () => {
    try {
      setCargando(true);
      const res = await api.get('/stripe/estado-conexion');
      setEstado(res.data);
    } catch (e) {
      setMensaje('Error al cargar el estado de tu cuenta de Stripe');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarEstado();
    const resultado = searchParams.get('stripe');
    if (resultado === 'conectado') {
      setMensaje('✅ ¡Tu cuenta de Stripe quedó conectada! A partir de ahora recibirás tu 80% directo en cada venta.');
    } else if (resultado === 'error') {
      setMensaje('❌ No se pudo conectar tu cuenta de Stripe. Intenta de nuevo.');
    }
    if (resultado) {
      searchParams.delete('stripe');
      setSearchParams(searchParams, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const conectar = async () => {
    setConectando(true);
    try {
      const res = await api.get('/stripe/conectar');
      window.location.href = res.data.url;
    } catch (e) {
      setMensaje('Error al generar el link de conexión con Stripe');
      setConectando(false);
    }
  };

  const desconectar = async () => {
    if (!window.confirm('¿Desconectar tu cuenta de Stripe? Tus próximas ventas volverán a pagarse por transferencia manual.')) return;
    setDesconectando(true);
    try {
      await api.post('/stripe/desconectar');
      await cargarEstado();
    } catch (e) {
      setMensaje('Error al desconectar tu cuenta');
    } finally {
      setDesconectando(false);
    }
  };

  if (cargando) return <LoadingSpinner mensaje="Cargando tu cuenta..." />;

  return (
    <div className="mi-cuenta">
      <h1>👤 Mi Cuenta</h1>

      {mensaje && <div className="mi-cuenta-mensaje">{mensaje}</div>}

      <div className="mi-cuenta-card">
        <h2>💳 Cobro automático con Stripe</h2>
        <p className="mi-cuenta-descripcion">
          Conecta tu propia cuenta de Stripe para recibir tu <strong>80%</strong> de cada
          venta de forma automática y directa, sin esperar a que el administrador haga una
          transferencia manual.
        </p>

        {estado?.conectado ? (
          <>
            <div className="mi-cuenta-estado conectado">✅ Tu cuenta de Stripe está conectada</div>
            <button className="btn-mp-desconectar" onClick={desconectar} disabled={desconectando}>
              {desconectando ? 'Desconectando...' : 'Desconectar cuenta'}
            </button>
          </>
        ) : (
          <>
            <div className="mi-cuenta-estado pendiente">⏳ Aún no has conectado tu cuenta de Stripe</div>
            <button className="btn-mp-conectar" onClick={conectar} disabled={conectando}>
              {conectando ? 'Redirigiendo...' : 'Conectar con Stripe'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MiCuenta;
